export type Brand = {
    brandKey: string;
    name: string;
    categories: string[];
    keywords: string[];
    advertiserDomains: string[];
    competingBrands: BrandSummary[];
    logoPath?: string;
    aiPresenceTopics?: string[];
    metaPages?: { country: string; page_id: string }[];
}

export type BrandPayload = Omit<Brand, 'competingBrands' | 'categories'> & {
    competingBrands: string[];
    aiPresenceTopics?: string[];
};

export type BrandsResponse = {
    brands: Brand[] | BrandSummary[];
    total: number;
}

export type BrandSummary = {
    name: string;
    brandKey: string;
}

export type ManagementRequest = {
    offset?: number;
    limit?: number;
    elaborate?: boolean;
    term?: string;
    sortBy?: string;
    sortDir?: 'asc' | 'desc';
}

export enum BrandManagementColumn {
    BRAND_KEY = 'brandKey',
    BRAND_NAME = 'name',
    KEYWORDS = 'keywords',
    ADVERTISER_DOMAINS = 'advertiserDomains',
    COMPETITORS = 'competingBrands',
    ACCOUNTS = 'accountNames',
    CREATED_AT = 'createdAt',
}

export type UsersBrands = {
    key: string;
    name: string;
}

export type UserBase = {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    role: string;
    verifiedEmail?: boolean;
};

export type User = UserBase & {
    brands: UsersBrands[];
    account: { key: string };
};

export type UserPayload = UserBase & {
    accountKey: string;
};

export type UserResponse = {
    users: User[],
    total: number
}

export enum UserManagementColumn {
    EMAIL = 'email',
    FIRST_NAME = 'firstName',
    LAST_NAME = 'lastName',
    ROLE = 'role',
    CONNECTED_BRANDS = 'brands',
    ACCOUNT = 'account',
    CREATED_AT = 'createdAt',
    LAST_LOGIN = 'lastLogin',
}

export type BrandLogoResponse = {
    logoURL: string;
}

export type Account = {
    name: string;
    accountKey: string;
    brands: string[];
    userIds: string[];
    createdAt: string;
}

export type AccountUser = {
    email: string;
    firstName: string;
    lastName: string;
}

export type AccountUsersResponse = {
    accountUsers: AccountUser[];
}

export enum AccountManagementColumn {
    NAME = 'name',
    BRANDS = 'brands',
    USERS = 'userIds',
    CREATED_AT = 'createdAt',
    ACCOUNT_KEY = 'accountKey'
}

export type AccountPayload = {
    accountKey: string;
    name: string;
    brandKeys: string[];
}

export type AccountSummary = {
    name: string;
    accountKey: string;
}

export type AccountsResponse = {
    brands: Account[] | AccountSummary[];
    total: number;
}

export type Topic = {
    id: string;
    name: string;
    brandKeys: string[];
}

export type AiTopicsResponse = {
  topics: Topic[];
  total: number;
}

